module.exports = __webpack_public_path__ + "media/img/eq_false-d4609236.png";